import React from "react";
import styled from "styled-components";
import { useExport } from "../../../../hooks/useExport";
import { Col, Row } from "react-bootstrap";










type IProps = {};

const BenefitsDetails = (props: IProps) => {


  const {
    whiteTextIcon
  } = useExport();


  const benefitItems = [
    {
      id: 1,
      benefit: "Competitive Advantage",
      benefitDescription:
        "A well-optimized GMB profile can give a small business a competitive edge in the local market. It can help you stand out from competitors who may not have optimized their online presence. Especially tourists and new visitors",
    },
    {
      id: 2,
      benefit: "Local SEO",
      benefitDescription:
        "A well-optimized GMB profile can improve a business's local search engine optimization (SEO), making it more likely to appear in search results when potential customers are looking for products or services in their area.",
    },
    {
      id: 3,
      benefit: "Customer Engagement",
      benefitDescription:
        "GMB profiles enable businesses to engage with their customers by responding to reviews, sharing updates, and offering essential information, like business hours, location, and contact details.",
    },
    {
      id: 4,
      benefit: "Online Visibility",
      benefitDescription:
        "This increased online presence can attract more potential customers to their physical or online stores.",
    },
  ];




  return (
    <>
      <Row>
        {benefitItems?.map((benefitItem) => (
          <Col
            sm={{ span: 12 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
            key={benefitItem?.id}
          >

            <RoundedCircle
              data-aos="fade-up"
              data-aos-once="true"
            >
              <img
                src={whiteTextIcon}
                alt="white text icon"
                style={{
                  width: "24px",
                  height: "24px",
                  objectFit: "contain",
                }}
              />
            </RoundedCircle>
            <div
              className="mb-5"
            >
              <Text
                data-aos="fade-up"
                data-aos-once="true"
                style={{
                  marginTop: "0.625rem"
                }}
              >
                {benefitItem?.benefit}
              </Text>
              <Text
                data-aos="fade-up"
                data-aos-once="true"
                style={{
                  fontWeight: 600,
                  fontSize: "14px",
                  lineHeight: "150%",
                  color: "#4f4f4f",
                  textAlign: "justify"
                }}
              >
                {benefitItem?.benefitDescription}
              </Text>
            </div>

          </Col>
        ))}
      </Row>


    </>
  );
};

export default BenefitsDetails;












const RoundedCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 50% !important;
  background-color: #201f4f;
  box-shadow: 0px 3.2px 6.4px rgba(0, 0, 0, 0.04),
    0px 0px 1.6px rgba(0, 0, 0, 0.06), 0px 0px 0.8px rgba(0, 0, 0, 0.04);
  text-align: center;
`;

const Text = styled.p`
  max-width: 346px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 140%;
  color: #eb8145;
`;

